import type { DetailedHTMLProps, ImgHTMLAttributes } from "react";
import avatarOfFrostJpeg from "../assets/AvatarOfFrost.jpg";
import avatarOfFrostWebp from "../assets/AvatarOfFrost.webp";

export const AvatarOfFrost = (
  props: DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >,
) => {
  return (
    <picture>
      <source srcSet={avatarOfFrostWebp.src} type="image/webp" />
      <img
        {...props}
        alt="Avatar of Frost"
        height={avatarOfFrostJpeg.height}
        src={avatarOfFrostJpeg.src}
        width={avatarOfFrostJpeg.width}
      />
    </picture>
  );
};
